import React from 'react';

import { HintWrapper } from './Hint.style';

export const Hint = () => (
  <HintWrapper>
    <span>Hint:</span>Type @@ to add personalised content
  </HintWrapper>
);
